<style lang="scss" scoped>
.product-category {
    .loading {
        display: flex;
        flex: 1;
        text-align: center;
        justify-content: center;
        align-items: center;
        min-height: 468px;
    }

    .component-fade-enter-active,
    .component-fade-leave-active {
        transition: opacity 0.3s ease;
    }
    .component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
}

::v-deep .vue-slider {
    .vue-slider-rail {
        @apply bg-gray-200;
    }
    .vue-slider-process {
        @apply bg-primary;
    }
    .vue-slider-dot-handle {
        @apply bg-primary;
        border-color: theme('colors.primary') !important;
    }
    .vue-slider-dot-tooltip {
        top: -4px;
    }
    .vue-slider-dot-tooltip-inner {
        @apply p-0 bg-transparent border-0 shadow-none text-primary;
    }
    .vue-slider-dot-tooltip-text {
        @apply text-16 font-medium;
    }
    .vue-slider-dot-tooltip-inner-top::after {
        display: none;
    }
    .vue-slider-mark-label {
        @apply text-16 font-medium;
    }
}
</style>

<template>
    <div class="product-category">
        <div class="flex items-start justify-between lg:mb-40 mb-16">
            <h1 class="h4 inline-block" v-html="title"></h1>
            <div class="self-stretch relative">
                <div @click="showSortDialog = !showSortDialog" class="inline-flex sort-dialog-toggle items-center cursor-pointer pt-16" :class="{ 'text-primary': showSortDialog }">
                    <span class="font-medium">{{ translations.sort }}</span
                    ><span v-html="svg('sort', 'ml-8')"></span>
                </div>
                <transition name="fade">
                    <div class="absolute z-50 top-full pt-2 right-0" v-click-outside="sortDialogClickOutside" v-if="showSortDialog">
                        <div class="bg-white min-w-[254px] flex flex-col rounded-xs border border-gray-100">
                            <span class="py-10 px-[15px] bg-white cursor-pointer hover:bg-gray-100 font-semibold" @click="sort = 'price_asc'" :class="{ 'text-primary': sort === 'price_asc' }">Prijs oplopend</span>
                            <span class="py-10 px-[15px] bg-white cursor-pointer hover:bg-gray-100 font-semibold" @click="sort = 'price_desc'" :class="{ 'text-primary': sort === 'price_desc' }">Prijs aflopend</span>
                            <span class="py-10 px-[15px] bg-white cursor-pointer hover:bg-gray-100 font-semibold" @click="sort = 'capacity_asc'" :class="{ 'text-primary': sort === 'capacity_asc' }">Draagkracht oplopend</span>
                            <span class="py-10 px-[15px] bg-white cursor-pointer hover:bg-gray-100 font-semibold" @click="sort = 'capacity_desc'" :class="{ 'text-primary': sort === 'capacity_desc' }">Draagkracht aflopend</span>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <transition name="component-fade" mode="out-in">
            <div v-if="ready" key="ready">
                <div class="flex flex-wrap lg:items-start -m-16">
                    <div class="w-full lg:w-1/4 p-16 flex flex-col">
                        <transition name="component-fade" mode="out-in">
                            <div class="flex items-center justify-center min-h-[180px]" v-if="filters.length === 0 && (filtersVisible || $root.screen.lg)">
                                <spinner></spinner>
                            </div>
                            <div v-else>
                                <template v-if="filtersVisible || $root.screen.lg">
                                    <transition-group name="component-fade" mode="out-in" tag="div" class="lg:-mb-40">
                                        <!--
                                        <div v-if="selectableCategories.length > 1" :key="'categories'">
                                            <div class="flex flex-col mb-40">
                                                <span class="text-20 font-bold text-gray-800 mb-16" v-html="translations.categories"></span>
                                                <transition-group name="component-fade" mode="out-in" tag="div" class="flex flex-col -mx-8">
                                                    <div v-for="category in selectableCategories" :key="`categories.${category.id}`" class="flex items-center select-none cursor-pointer justify-between rounded-xs hover:bg-gray-100 transition-colors py-10 px-8" @click="toggleCategory(category.id)">
                                                        <span class="font-medium leading-[1.375rem]" v-html="category.name"></span>
                                                        <el-input :value="activeCategories.includes(category.id)" type="checkbox"></el-input>
                                                    </div>
                                                </transition-group>
                                            </div>
                                        </div>-->
                                        <div
                                            v-for="filter in filters
                                                .filter(f => f.results.length > 0 && f.type !== 'opp_calc')
                                                .sort((a, b) => {
                                                    if (a.ordinal < b.ordinal) return -1;
                                                    if (a.ordinal > b.ordinal) return 1;
                                                    return 0;
                                                })"
                                            :key="filter.key"
                                        >
                                            <div class="flex flex-col mb-40">
                                                <span class="text-20 font-bold text-gray-800 mb-16" v-html="filter.name"></span>
                                                <transition-group name="component-fade" mode="out-in" tag="div" class="flex flex-col -mx-8" v-if="filter.type === 'string' || filter.type === 'template'">
                                                    <div v-for="result in filter.results" :key="`${filter.key}.${result.term}`" class="flex items-center select-none cursor-pointer justify-between rounded-xs hover:bg-gray-100 transition-colors py-10 px-8" @click="toggleFilter({ key: filter.field, term: result.term })">
                                                        <span class="font-medium leading-[1.375rem]" v-html="result.term"></span>
                                                        <el-input :value="activeFilters.find(f => f.term === result.term && f.key === filter.field)" type="checkbox"></el-input>
                                                    </div>
                                                </transition-group>
                                                <transition-group name="component-fade" mode="out-in" tag="div" class="flex flex-col -mx-8" v-if="filter.type === 'boolean'">
                                                    <div v-for="result in filter.results" :key="`${filter.key}.${result.term}`" class="flex items-center select-none cursor-pointer justify-between rounded-xs hover:bg-gray-100 transition-colors py-10 px-8" @click="toggleFilter({ key: filter.field, term: result.term === '1' ? 'true' : 'false' })">
                                                        <span class="font-medium leading-[1.375rem]" v-html="translations[`${filter.key}_${result.term}`]"></span>
                                                        <el-input :value="activeFilters.find(f => f.key === filter.field && ((result.term === '1' && f.term === 'true') || (result.term === '0' && f.term === 'false')))" type="checkbox"></el-input>
                                                    </div>
                                                </transition-group>
                                                <transition name="component-fade" mode="out-in" tag="div" class="flex flex-col relative" v-if="filter.type === 'number'">
                                                    <div class="relative px-8 pt-16">
                                                        <vue-slider
                                                            @change="
                                                                backdoor++;
                                                                sliders[filter.field].touched = true;
                                                            "
                                                            v-model="sliders[filter.field].value"
                                                            tooltip="always"
                                                            :marks="[sliders[filter.field].min, sliders[filter.field].max]"
                                                            :min="sliders[filter.field].min"
                                                            :max="sliders[filter.field].max"
                                                        />
                                                    </div>
                                                </transition>
                                            </div>
                                        </div>
                                    </transition-group>
                                </template>
                                <div @click="filtersVisible = !filtersVisible" class="lg:hidden flex select-none items-center text-20 font-medium">
                                    <span class="mr-4">{{ translations.filter }}</span
                                    ><span class="transition-transform" :class="{ 'rotate-180': filtersVisible }" v-html="svg('chevron-down', 'h-16 w-auto translate-y-1')"></span>
                                </div>
                            </div>
                        </transition>
                    </div>
                    <div class="flex w-full lg:w-3/4 p-16 flex-wrap">
                        <transition-group name="component-fade" tag="div" class="-m-8 md:-m-16 flex-1 flex flex-wrap" mode="out-in">
                            <div v-for="product in products" :key="product.id" class="w-1/2 lg:w-1/3 flex flex-col p-8 md:p-16">
                                <product-card :variants="product.variants" :title="product.name" :is-top="product.is_top" :description="product.introduction && product.introduction != '' ? product.introduction : product.description" :media="product.media" :link="`${$root.productUrl}/${product.slug}`"></product-card>
                            </div>
                            <div v-if="products.length === 0" key="no-products" v-html="translations.no_products"></div>
                        </transition-group>
                    </div>
                </div>
            </div>
            <div key="loading" v-else class="loading">
                <spinner></spinner>
            </div>
        </transition>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';
const debounce = require('lodash.debounce');

export default {
    name: 'Ui.ProductOverview',

    directives: { ClickOutside },

    components: {
        VueSlider,
    },

    props: {
        categories: {
            type: Array,
            default: () => [],
        },
        perPage: {
            type: Number,
            default: 1000,
        },
        title: {
            type: String,
            required: true,
        },
        translations: {
            type: Object,
            required: true,
        },
        allCategories: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            ready: false,
            backdoor: 0,
            products: [],
            filters: [],
            activeFilters: [],
            activeCategories: [],
            idsSortedByOrdinal: [],
            sliders: {},
            sort: null,
            filtersVisible: false,
            showSortDialog: false,
        };
    },

    async mounted() {
        const url = new URL(window.location.href);
        url.searchParams.forEach((v, k) => {
            if (k === 'categories[]') {
                this.activeCategories.push(parseInt(v));
                return;
            }
            this.activeFilters.push({ key: k, term: v });
        });

        if (this.activeCategories.length || this.categories.length) {
            await this.getIdsSortedByOrdinal(); // just do this once because categories are not changing
        }

        this.getProducts().then(
            () => {
                this.ready = true;
                this.getProductFilters();
            },
            function(error) {
                console.log(error);
            },
        );
    },

    methods: {
        getProducts() {
            const self = this;
            const searchParams = this.filterQueryParams;

            return new Promise(function(resolve, reject) {
                axios
                    .get(`/api/filtered-products?${searchParams.toString()}&total=${self.perPage}`)
                    .then(function(response) {
                        if (!self.sort && self.idsSortedByOrdinal.length > 0) {
                            response.data.sort((a, b) => {
                                return self.idsSortedByOrdinal.indexOf(a.id) - self.idsSortedByOrdinal.indexOf(b.id);
                            });
                        }

                        self.products = response.data;
                        resolve(response.data);
                    })
                    .catch(function(error) {
                        reject(error);
                    });
            });
        },

        getProductsDebounced: debounce(function(e) {
            this.getProducts();
        }, 500),

        getProductFilters: debounce(function(e) {
            const searchParams = this.filterQueryParams;

            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/product-filters?${searchParams.toString()}`)
                    .then(response => {
                        this.filters = response.data;

                        if (!this.sliders || Object.keys(this.sliders).length === 0) {
                            this.initSliders();
                        }

                        resolve(response.data);
                    })
                    .catch(function(error) {
                        reject(error);
                    });
            });
        }, 500),

        getIdsSortedByOrdinal() {
            const self = this;
            axios
                .get(`/api/collects?categories[]=${[...new Set([...this.categories, ...this.activeCategories])].join(',')}&total=${self.perPage}`)
                .then(function(response) {
                    self.idsSortedByOrdinal = response.data.map(c => c.product_id);
                })
                .catch(function(error) {});
        },

        toggleFilter(filter) {
            const index = this.activeFilters.findIndex(f => f.key === filter.key);

            if (index === -1) {
                this.activeFilters.push(filter);
            } else if (this.activeFilters[index].term === filter.term) {
                this.activeFilters.splice(index, 1);
            } else {
                this.activeFilters.push(filter);
            }
        },

        /*
        toggleCategory(categoryId) {
            const index = this.activeCategories.indexOf(categoryId);

            if (index === -1) {
                this.activeCategories.push(categoryId);
            } else {
                this.activeCategories.splice(index, 1);
            }
        },*/

        sortDialogClickOutside(event) {
            if (event.target.closest('.sort-dialog-toggle') == null) {
                this.showSortDialog = false;
            }
        },

        initSliders() {
            this.sliders = new Object();
            this.filters
                .filter(f => f.type === 'number' && f.results.length > 0)
                .forEach(f => {
                    const values = f.results.map(r => parseInt(r.term)).sort((a, b) => a - b);
                    const min = values[0];
                    const max = values[values.length - 1];

                    const currentValueMin = this.activeFilters.find(af => af.key === `gte:${f.field}`)?.term;
                    const currentValueMax = this.activeFilters.find(af => af.key === `lte:${f.field}`)?.term;
                    this.sliders[f.field] = {
                        value: [currentValueMin ?? min, currentValueMax ?? max],
                        min: min,
                        max: max,
                        touched: currentValueMin != undefined || currentValueMax != undefined,
                    };
                });
        },

        setUrlQueryParams() {
            const url = new URL(window.location.href.split('?')[0]);
            this.filterQueryParams.forEach((v, k) => {
                if (k !== 'locale') {
                    url.searchParams.append(k, v);
                }
            });
            window.history.pushState({}, '', url);

            this.getProductsDebounced();
            this.getProductFilters();
        },
    },

    computed: {
        filterQueryParams() {
            const searchParams = new URLSearchParams();
            this.backdoor; // backdoor to force computed update when sliders input changed

            searchParams.append('locale', document.documentElement.lang);
            [...new Set([...this.categories, ...this.activeCategories])].forEach(categoryId => {
                searchParams.append('categories[]', categoryId);
            });

            if (this.activeFilters.length) {
                let flattenedFilters = new Object();
                this.activeFilters.forEach(f => {
                    if (!Object.keys(flattenedFilters).includes(f.key)) {
                        flattenedFilters[f.key] = f.term;
                    } else {
                        flattenedFilters[f.key] = flattenedFilters[f.key] + '|' + f.term;
                    }
                });

                Object.keys(flattenedFilters).forEach(k => {
                    searchParams.append(k, flattenedFilters[k]);
                });
            }

            if (this.sliders && Object.keys(this.sliders).length) {
                Object.keys(this.sliders).forEach(k => {
                    if (!this.sliders[k].touched) {
                        return;
                    }
                    searchParams.append(`gte:${k}`, this.sliders[k].value[0]);
                    searchParams.append(`lte:${k}`, this.sliders[k].value[1]);
                });
            }

            if (this.sort) {
                searchParams.append('s', this.sort);
            }

            return searchParams;
        },
        selectableCategories() {
            return this.allCategories.filter(category => !this.categories.includes(category.id));
        },
    },

    watch: {
        filterQueryParams: {
            handler: function(filterQueryParams) {
                if (this.ready) {
                    this.setUrlQueryParams();
                }
            },
        },

        sort: {
            handler: function(sort) {
                this.showSortDialog = false;
                this.getProductsDebounced();
            },
        },
    },
};
</script>
